import { serverResponse } from 'app'

export * from './fetch'
export * from './like'
export * from './relation'
export * from './stageTeamRelocate'
export * from './statsGenerate'

export const getInitialState = () => serverResponse()
